import { useAppDispatch } from '@store';
import { IconArrowLeft, IconArrowRight, IconSelected, Popup } from '@ui/src';
import {
  generatePath,
  NavLink,
  Outlet,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { ApplicationWrapperTypes } from './types';
import { clearNewApplicationInfoState, setHintVisible } from '../store/slices';

import ROUTES from '../../../../routes';

import cn from '../../common/styles.module.css';

const ApplicationWrapper = ({
  isDirty,
  questionnarieIsDirty,
  setDirtyPopupVisible,
  children,
  hintVisible,
  newApplicationInfo,
  dirtyPopupVisible,
}: ApplicationWrapperTypes) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { search, state } = useLocation();

  return (
    <div className={cn.newApplicationInfo}>
      <div className={cn.newApplicationLinkWrapper}>
        <button
          type="button"
          className={cn.newApplicationBackLink}
          onClick={() => {
            if (isDirty || questionnarieIsDirty) {
              setDirtyPopupVisible(true);
            } else {
              navigate(
                state && state.applicationId
                  ? generatePath(
                      ROUTES.CUSTOMERS_NEW_APPLICATION_CORPORATE_INFO,
                      {
                        applicationId: state.applicationId,
                      },
                    )
                  : `${ROUTES.CUSTOMERS_NEW_APPLICATION_LIST}${search || ''}`,
              );
              dispatch(clearNewApplicationInfoState());
            }
          }}
        >
          <IconArrowLeft width={13} height={11} />
          Back
        </button>
      </div>
      {children}
      <Outlet />
      {hintVisible && (
        <div className={cn.customerCreatedSuccessful}>
          <div className={cn.customerCreatedSuccessfulLeft}>
            <span>
              <IconSelected />
            </span>
            <span>Customer created</span>
          </div>
          <div className={cn.customerCreatedSuccessfulRight}>
            <span>
              <NavLink
                to={generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_PAGE, {
                  customerId: (newApplicationInfo?.userId as string) || '',
                })}
              >
                <IconArrowRight />
                Open application
              </NavLink>
            </span>
            <button
              type="button"
              className={cn.hintCloseButton}
              onClick={() => dispatch(setHintVisible(false))}
            >
              Close
            </button>
          </div>
        </div>
      )}
      <Popup
        title="You have unsaved changes"
        description=""
        onCancelClick={() => setDirtyPopupVisible(false)}
        onOkClick={() =>
          navigate(
            state && state.applicationId
              ? generatePath(ROUTES.CUSTOMERS_NEW_APPLICATION_CORPORATE_INFO, {
                  applicationId: state.applicationId,
                })
              : `${ROUTES.CUSTOMERS_NEW_APPLICATION_LIST}${search || ''}`,
          )
        }
        cancelButtonText="Cancel"
        okButtonText="Close"
        isVisible={dirtyPopupVisible}
      />
      <div id="signature-popup" />
    </div>
  );
};

export default ApplicationWrapper;
